import { formatAgo } from '@/shared/lib/format';
import type { ClaudeCodeConnectionData, CodexConnectionData } from '@/shared/types/workspace';

export function claudeNote(connection: ClaudeCodeConnectionData): string {
  if (connection.status === 'NOT_CONNECTED')
    return 'Needs a Claude Team or Enterprise organization';
  if (connection.status === 'KEY_REJECTED') return 'Replace the key in Connections';
  const name = connection.environmentName ?? 'Environment key saved';
  return connection.lastSessionAt
    ? `${name}, last session ${formatAgo(connection.lastSessionAt)}`
    : `${name}, no sessions yet`;
}

export function codexNote(connection: CodexConnectionData): string {
  if (connection.status === 'NOT_CONNECTED') return 'OpenAI Agents API webhook';
  if (connection.status === 'WAITING') return 'Waiting for the first event';
  return connection.lastEventAt ? `Last event ${formatAgo(connection.lastEventAt)}` : 'Connected';
}
